import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton, Tooltip } from '@mui/material';
import { useHelp } from '../hooks/useHelp';

export type HelpTriggerProps = {
  articleId?: string;
  category?: string;
  label?: string;
  size?: 'small' | 'medium';
};

export default function HelpTrigger({
  articleId,
  category,
  label = 'Ouvrir l’aide contextuelle',
  size = 'small',
}: HelpTriggerProps) {
  const { openHelp } = useHelp();

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        size={size}
        onClick={() => openHelp(articleId, category)}
        sx={{
          color: 'rgba(36, 52, 40, 0.6)',
          border: '1px solid rgba(36, 52, 40, 0.12)',
          '&:hover': {
            bgcolor: 'rgba(36, 52, 40, 0.04)',
          },
        }}
      >
        <HelpOutlineIcon fontSize={size === 'small' ? 'small' : 'medium'} />
      </IconButton>
    </Tooltip>
  );
}
